import React from 'react';
import { Button, EButtonType, KitIcons } from '@repo/apg-ui';
import classNames from 'classnames';
import { ReactComponent as Edit } from '../../../assets/icons/edit_outline.svg';
import { ReactComponent as AddToBucket } from '../../../assets/icons/new/add_to_basket.svg';
import { ReactComponent as RemoveIcon } from '../../../assets/icons/new/trash.svg';
import { ReactComponent as RedX } from '../../../assets/icons/redX.svg';
import { ReactComponent as Check } from '../../../assets/icons/check.svg';
import { formatNumber } from '../../../utils/react';

import './MapResultPopup.scss';
import { useNavigate } from 'react-router';
import Tooltip from 'rc-tooltip';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  locations: any;
  intl: any;
  basketEntries?: Object;
  overviewJ1?: boolean;
  overviewJ2?: boolean;
  loading?: boolean;
  activeMarkerName: string;
  isMarkerColorGrey: boolean;
  handleProductSelectClick: any;
  isBookedInPeriod?: any;
  findProductInBasket?: any;
}

export const MapResultPopup = ({
  isOpen,
  onClose,
  locations,
  intl,
  basketEntries,
  overviewJ1,
  overviewJ2,
  loading,
  activeMarkerName,
  isMarkerColorGrey,
  handleProductSelectClick,
  isBookedInPeriod = null,
  findProductInBasket = null,
}: Props) => {
  const navigate = useNavigate();
  const producturn = locations[activeMarkerName]?.producturn;
  const format = locations[activeMarkerName]?.format;
  const address = locations[activeMarkerName]?.address;
  // const mediacount = locations[activeMarkerName]?.mediacount;
  const productshortcut = locations[activeMarkerName]?.attributeshortcuts;
  const isProductBookedInPeriod =
    isBookedInPeriod && basketEntries && isBookedInPeriod(locations[activeMarkerName], basketEntries[producturn]);
  const isDigiflex = locations[activeMarkerName]?.producttype === 'digital';
  const bookedProduct = isProductBookedInPeriod
    ? findProductInBasket(locations[activeMarkerName], basketEntries[producturn])
    : null;
  const basketkey = bookedProduct && bookedProduct.basketkey;
  console.log('basketEntries', basketEntries);

  return (
    isOpen && (
      <React.Fragment>
        <div className='map-result-popup w-100' id={'mapResultPopup'}>
          <div className='d-flex p-4 product-name'>
            <h4 className='w-100 fw-bold font-24 mb-0'>
              {format}
              {productshortcut}
            </h4>
            <div onClick={onClose} className='close-icon'>
              <KitIcons.CloseIcon />
            </div>
          </div>

          <div
            className={classNames('p-0 w-100', {
              'product-image':
                locations && locations[activeMarkerName] && !locations[activeMarkerName]?.productphotopath,
            })}
          >
            <div className='product-img-wrapper'>
              <img
                alt='Product'
                className='product-img w-100'
                src={locations[activeMarkerName]?.productphotopath + '&resolution=thumbnail'}
              />
            </div>
          </div>

          <div className='p-16 d-flex flex-column justify-content-start product-info'>
            <div className='w-100 d-flex flex-row justify-content-between'>
              <div className='d-flex flex-row justify-content-start'>
                <div className='badge bg-light product-code'>
                  <span>ID: {locations[activeMarkerName]?.productid}</span>
                </div>

                {isMarkerColorGrey && (
                  <div className='d-flex justify-content-start ms-4 availability'>
                    <span className='unavailable-checker ps-0'>
                      <RedX />
                    </span>

                    <span className='ps-0 font-14 font-600'>
                      {intl.formatMessage({
                        id: 'ec.journey02.unavailable',
                        defaultMessage: 'Nicht verfügbar',
                      })}
                    </span>
                  </div>
                )}

                {locations[activeMarkerName]?.shopstate === 0 && !isMarkerColorGrey && (
                  <div className='d-flex justify-content-start ms-4 availability'>
                    <span className='green-checker ps-0'>
                      <Check />
                    </span>
                    <span className='ps-0 font-14 font-600'>
                      {intl.formatMessage({
                        id: 'ec.journey02.available',
                        defaultMessage: 'Verfügbar',
                      })}
                    </span>
                  </div>
                )}
              </div>

              <div className='d-flex justify-content-end align-items-center'>
                <div className='mb-0 fw-bold font-18'>
                  <span className='me-2'>
                    {intl.formatMessage({
                      id: 'ec.journey02.chf',
                      defaultMessage: 'CHF',
                    })}
                  </span>
                  <span>
                    {formatNumber(
                      basketEntries && basketEntries[producturn]
                        ? basketEntries[producturn].standardprice
                        : locations[activeMarkerName]?.standardprice,
                      2,
                    )}
                  </span>
                </div>
              </div>
            </div>

            <p className='font-500 font-14 mt-24 mb-0 address'>{address}</p>

            {basketEntries && basketEntries[producturn]?.length > 1 ? (
              <p style={{ marginTop: '10px', color: 'red', lineHeight: '1.8rem' }}>
                {intl.formatMessage({
                  id: 'ec.modals.resultList.cantShowButtonsExplanation',
                  defaultMessage: 'Editieren von mehren Zeiträumen nur über Listansicht möglich',
                })}
              </p>
            ) : (
              <div className='d-flex flex-column justify-content-start ms-0 mt-3'>
                <Button
                  id={`productView${producturn}`}
                  buttonType={EButtonType.InvertedPillMedium}
                  onClick={() => {
                    navigate({
                      search: `modalContent=${isDigiflex ? 'digiflex' : 'analog'}&urn=${producturn}&basketkey=${isProductBookedInPeriod ? basketkey : null}`,
                    });
                  }}
                >
                  <Tooltip
                    overlayClassName={'rc-tooltip-bg-white'}
                    placement={'left'}
                    overlayStyle={{ zIndex: 9999999999 }}
                    overlay={
                      <b>
                        {intl.formatMessage({
                          id: 'ec.general.editProductAnalog',
                          defaultMessage: 'Details anpassen',
                        })}
                      </b>
                    }
                  >
                    <div className='d-flex justify-content-center align-items-center h-100'>
                      <Edit className='edit-svg-icon' />
                    </div>
                  </Tooltip>
                </Button>

                <Button
                  className='font-600'
                  id={`productSelect${producturn}`}
                  buttonType={!isProductBookedInPeriod ? EButtonType.PillMedium : EButtonType.InvertedPillMedium}
                  onClick={() => {
                    handleProductSelectClick(bookedProduct, !isProductBookedInPeriod);
                  }}
                  isLoading={loading}
                >
                  <Tooltip
                    overlayClassName={'rc-tooltip-bg-white'}
                    placement={'left'}
                    overlayStyle={{ zIndex: 9999999999 }}
                    overlay={
                      <b>
                        {isProductBookedInPeriod
                          ? intl.formatMessage({
                              id: 'ec.components.buttons.journey02.cancelBooking',
                              defaultMessage: 'Entfernen',
                            })
                          : intl.formatMessage({
                              id: 'ec.components.buttons.journey02.book',
                              defaultMessage: 'Hinzufügen',
                            })}
                      </b>
                    }
                  >
                    <>
                      {!isProductBookedInPeriod && (
                        <div className='d-flex justify-content-center align-items-center h-100'>
                          <AddToBucket />
                        </div>
                      )}
                      {isProductBookedInPeriod && (
                        <div className='remove-action'>
                          <RemoveIcon />
                        </div>
                      )}
                    </>
                  </Tooltip>
                </Button>
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    )
  );
};
